import firebase from '@app/plugins/firebase'
import { readFeatureFlagOverride } from '@app/utils/featureFlagOverride'
import { assertFeatureFlagStorage } from '@app/utils/featureFlagStorage'
import {
  createFeatureFlagController,
  featureFlagState,
  configureFeatureFlagRequest,
} from '@app/utils/featureFlags'

export default function () {
  const override = readFeatureFlagOverride()
  if (override) {
    featureFlagState.values = override
    configureFeatureFlagRequest(() => Promise.resolve())
    return
  }
  const controller = createFeatureFlagController(
    async () => {
      await assertFeatureFlagStorage()
      return firebase.remoteConfig()
    },
    (values) => {
      featureFlagState.values = values
    },
    // v8 Installations.getId logs registration failures via console.error.
    // Complete registration/token refresh first using the public getToken API,
    // whose rejection is caught by the controller, before RC calls getId.
    () => firebase.app().installations().getToken()
  )
  configureFeatureFlagRequest(controller.refresh)
}
